import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LEARN_ABOUT_HS_VIDEO_LINK } from '../../Constants';
import { connect } from 'react-redux';
import * as trackingActions from '../../actions/tracking';
import { getVideoLimit, getShouldUserDowngradeVideo2 } from '../../selectors/Limits';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getI18nKey = suffix => `FileManagerCore.downgradeVideo.${suffix}`;
const VideoDowngradeAlert = ({
  videoLimit,
  onTrackInteraction,
  key,
  className,
  shouldUserDowngradeVideo2
}) => {
  if (shouldUserDowngradeVideo2) {
    const daysRemainingToDowngrade = videoLimit.get('daysRemainingToDowngrade');
    return /*#__PURE__*/_jsxs(UIAlert, {
      className: className,
      type: "danger",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: getI18nKey(typeof daysRemainingToDowngrade === 'number' ? 'title' : 'titleWithoutDaysRemaining'),
        options: {
          downgradeCount: videoLimit.get('quantityUsed') - videoLimit.get('quantityAllowed'),
          daysRemainingToDowngrade
        }
      }),
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: getI18nKey('message'),
        options: {
          usedVideoCount: videoLimit.get('quantityUsed'),
          limit: videoLimit.get('quantityAllowed')
        }
      }), /*#__PURE__*/_jsx(UILink, {
        className: "m-left-2",
        href: LEARN_ABOUT_HS_VIDEO_LINK,
        external: true,
        use: "on-bright",
        onClick: () => onTrackInteraction('fileManagerVideoPQL', 'learn more about downgrades', {
          alert: 'downgrades alert'
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getI18nKey('learnMoreAboutDowngrades')
        })
      })]
    }, key);
  }
  return null;
};
const mapStateToProps = state => {
  return {
    videoLimit: getVideoLimit(state),
    shouldUserDowngradeVideo2: getShouldUserDowngradeVideo2(state)
  };
};
const mapDispatchToProps = {
  onTrackInteraction: trackingActions.trackInteraction
};
export default connect(mapStateToProps, mapDispatchToProps)(VideoDowngradeAlert);